<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Leave Requests</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <leave-request-form v-if="pagepermission.insertable" @saved="handleCreated"/>
        </div>
      </div>
    </div>

    <div class="row align-items-center mb-2" v-if="pagepermission.viewable">
      <!-- Session Select -->
      <div class="col-md-2 col-12 mb-2">
        <a-select
          size="large"
          v-model="selectedSession"
          optionFilterProp="children"
          style="width: 100%"
          @change="handleSessionChange"
          :filterOption="false"
          :defaultValue="currentSession ? currentSession.id : ''"
        >
        <template v-for="schoolSession in schoolSessions">
          <a-select-option :value="schoolSession.id" :key="schoolSession.id">
              {{schoolSession.name}}
              <small class="text-primary ml-2">{{ currentSession.id === schoolSession.id ? 'Current' : '' }}</small>
          </a-select-option>
        </template>
        </a-select>
      </div>
      <!-- Class Select -->
      <div class="col-md-2 col-12 mb-2">
        <a-spin :spinning="classSpinning">
          <a-select
            size="large"
            v-model="selectedClass"
            placeholder="All Classes"
            optionFilterProp="children"
            style="width: 100%"
            @change="handleClassSelect"
            :filterOption="false"
            :defaultValue="undefined"
          >
            <a-select-option :value="undefined">All Classes</a-select-option>
            <template v-for="schoolClass in schoolClasses">
              <a-select-option :value="schoolClass.id" :key="schoolClass.id">
              {{schoolClass.name}}
              </a-select-option>
            </template>
          </a-select>
        </a-spin>
      </div>
      <!-- Section Select -->
      <div class="col-md-2 col-12 mb-2">
        <a-spin :spinning="sectionSpinning">
          <a-select
          size="large"
            v-model="selectedSection"
            placeholder="All Sections"
            optionFilterProp="children"
            style="width: 100%"
            @change="handleSectionChange"
            :filterOption="false"
            :defaultValue="undefined"
            :disabled="!selectedClass"
          >
            <a-select-option :value="undefined">All Sections</a-select-option>
            <template v-for="section in sections">
              <a-select-option :value="section.id" :key="section.id">
              {{section.name}}
              </a-select-option>
            </template>
          </a-select>
        </a-spin>
      </div>
      <!-- Status Select -->
      <div class="col-md-2 col-12 mb-2">
          <a-select
          size="large"
            v-model="selectedStatus"
            placeholder="All Status"
            optionFilterProp="children"
            style="width: 100%"
            @change="handleStatusChange"
            :filterOption="false"
            :defaultValue="undefined"
          >
            <a-select-option :value="undefined">All Status</a-select-option>
            <template v-for="status in statuses">
              <a-select-option :value="status.value.toString()" :key="status.value">
                {{status.name}}
              </a-select-option>
            </template>
          </a-select>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <leave-request-table :rolesetting="pagepermission" :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import { find } from 'lodash'
import { statuses } from '@/components/leaverequest/data'

import LeaveRequestTable from '@/components/leaverequest/Table/index'
import LeaveRequestForm from '@/components/leaverequest/Form/index'

export default {
  components: {
    LeaveRequestTable,
    LeaveRequestForm,
  },
  beforeMount: function () {
    let rc = this.$roleutility.checkpermission('leave-request', 22)
    rc.then(data => {
      console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
    this.$http.get('/api/session')
      .then(({ data }) => {
        this.schoolSessions = data.data
        this.selectedSession = find(data.data, ['is_current', 1]).id
        this.getClasses()
      })
      .catch(error => {
        console.log(error)
      })
    this.getLeaveRequests()
  },
  computed: {
    currentSession: function() {
      const session = find(this.schoolSessions, ['is_current', 1])
      return session
    },
  },
  watch: {
    currentSession: function (val) {
      this.selectedSession = val.id
    },
  },
  data: function() {
    return {
      statuses,
      loading: false,
      visible: false,
      data: [],
      meta: {},
      schoolClasses: [],
      sections: [],
      schoolSessions: [],
      selectedClass: undefined,
      selectedSection: undefined,
      selectedSession: undefined,
      selectedStatus: undefined,
      sectionSpinning: false,
      classSpinning: false,
      current: 1,
      pageSize: 30,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    getLeaveRequests: function() {
      this.loading = true
      this.$http.get('/api/student/leave_requests/all', {
        params: {
          class_id: this.selectedClass,
          section_id: this.selectedSection,
          status: this.selectedStatus,
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleCreated: function() {
      this.getLeaveRequests()
    },
    handleUpdateTable: function() {
      this.getLeaveRequests()
    },
    getClasses() {
      this.classSpinning = true
      this.$http.get('/api/class', {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.schoolClasses = data.data
          this.classSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClassSelect(value) {
      this.selectedSection = undefined
      if (value) {
        this.sectionSpinning = true
        this.getClassSections(value)
      }
      this.getLeaveRequests()
    },
    getClassSections(value) {
      this.$http.get(`/api/section/class/${value}`, {
        params: {
          session_id: this.selectedSession,
        },
      })
        .then(({ data }) => {
          this.sections = data.data
          this.sectionSpinning = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleSectionChange (value) {
      if (value) {
        this.selectedSection = value
        this.getLeaveRequests()
      } else {
        this.selectedSection = undefined
        this.getLeaveRequests()
      }
    },
    handleStatusChange (value) {
      if (value) {
        this.selectedStatus = value
        this.getLeaveRequests()
      } else {
        this.selectedStatus = undefined
        this.getLeaveRequests()
      }
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }
      this.selectedSection = undefined
      this.selectedClass = undefined

      this.getClasses()
      this.getLeaveRequests()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getLeaveRequests()
    },
    onChange(current) {
      this.current = current
      this.getLeaveRequests()
    },
  },
}
</script>
<style>
  .error { padding: 25px 5px; }
</style>
